import CanvasBuccal from './CanvasBuccal';
export default CanvasBuccal;